import React, { useState, useEffect } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import "./about-style.scss";
import ABOUT_IMAGE from "../../images/potrait.jpg"

export const About = () => {
  const { translations: t, language } = useLanguage();
  const ABOUT = t.about[0];
  const [age, setAge] = useState(0);

  const calculateAge = (birthDate: any) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDateObj.getDate())) { age-- }
    return age;
  };

  useEffect(() => {
    setAge(calculateAge(ABOUT.birthDate));
  }, [ABOUT.birthDate]);

  const downloadCV = () => {
    const cvFile = language === 'en' 
      ? '/Jonathan Cocuy CV-EN.pdf' 
      : '/Jonathan Cocuy CV-ES.pdf';
      
    const link = document.createElement('a');
    link.href = cvFile;
    link.download = language === 'en' ? 'JonathanCocuyCV-EN.pdf' : 'JonathanCocuyCV-ES.pdf';
    link.click();
  };

  return (
    <div className="about_container">
      <div className="about_content_wrapper">
        <div className="image_column">
          {/* Volvemos al div normal sin TiltBox */}
          <div className="image_wrapper">
            <img className="image_about" src={ABOUT_IMAGE} alt="Jonathan Cocuy" />
            <div className="image_border"></div>
          </div>
        </div>
        
        <div className="text_column">
          <div className="text_card">
            <span className="section_badge">{ABOUT.title}</span>
            {/* Volvemos al h2 normal sin TextReveal */}
            <h2 className="main_title">{ABOUT.subtitle}</h2>
            <div className="description">
              <span dangerouslySetInnerHTML={{__html: ABOUT.paragraph}} />
            </div>
            
            <div className="info_grid">
              <div className="info_item" dangerouslySetInnerHTML={{__html: ABOUT.item1}} />
              <div className="info_item" dangerouslySetInnerHTML={{__html: ABOUT.item2}} />
              <div className="info_item">
                 {/* Combinamos el label del JSON con el cálculo dinámico */}
                  <span dangerouslySetInnerHTML={{__html: ABOUT.item3}} />
                  <span style={{marginLeft: '5px'}}>{age} {language === 'en' ? 'Years' : 'Años'}</span>
              </div>
              <div className="info_item" dangerouslySetInnerHTML={{__html: ABOUT.item4}} />
            </div>

            <button className="download_btn" onClick={downloadCV}>
              {ABOUT.button}
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
